export default __webpack_public_path__ + "static/media/title_ja_pc.382876af.png";